// extracted by mini-css-extract-plugin
export default {"wrapper":"FP-z","availablePromoMessagesLabel":"GP-z","promoMessageList":"HP-z","promoMessage":"IP-z","appliedPromoMessage":"JP-z","promoMessageAmount":"KP-z"};